import { Link } from "react-router-dom";
import { useFetch } from "../hooks/useFetch";
import { ErrorBanner } from "../components/ErrorBanner";
import {
  EmptyState,
  LoadingState,
  PageHeader,
  StatusBadge,
} from "../components/ui";

interface StudentTestRow {
  id: string;
  title: string;
  description: string | null;
  status: "draft" | "active" | "closed" | "archived";
  starts_at: string | null;
  ends_at: string | null;
  duration_minutes: number | null;
}
interface ListResponse {
  tests: StudentTestRow[];
}

export function StudentDashboardPage() {
  const { data, loading, error } = useFetch<ListResponse>("/student/tests");

  return (
    <section>
      <PageHeader
        title="Your tests"
        subtitle="Open an active test or check the results of your past attempts."
        actions={<Link to="/student/results">View my results →</Link>}
      />
      <ErrorBanner error={error} />
      {loading ? (
        <LoadingState />
      ) : data && data.tests.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>Title</th>
              <th>Status</th>
              <th>Duration</th>
              <th>Open</th>
            </tr>
          </thead>
          <tbody>
            {data.tests.map((t) => (
              <tr key={t.id}>
                <td>{t.title}</td>
                <td>
                  <StatusBadge status={t.status} />
                </td>
                <td>
                  {t.duration_minutes ? `${t.duration_minutes} min` : "—"}
                </td>
                <td>
                  {t.status === "active" ? (
                    <Link to={`/student/tests/${t.id}`}>Open</Link>
                  ) : (
                    <span aria-disabled>—</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <EmptyState
          title="No tests assigned yet"
          hint="When your teacher assigns a test, it will appear here."
        />
      )}
    </section>
  );
}
